module.exports = __webpack_public_path__ + "static/img/蓝谷智库.fbfa39f4.png";